import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 10c-49.6 0-90 40.4-90 90s40.4 90 90 90 90-40.4 90-90c0-49.7-40.4-90-90-90zm58.5 74.2-31.8 24.7 10.6 38.9c.4 1.5-.1 3.1-1.4 4-.6.5-1.4.7-2.2.7-.7 0-1.4-.2-2.1-.6L100 130.8l-31.7 21.1c-1.3.9-3 .8-4.3-.1-1.2-.9-1.9-2.6-1.4-4l10.6-38.9-31.7-24.7c-1.2-1-1.7-2.7-1.2-4.2s2-2.6 3.6-2.6h38.7l14.1-35.2c1.1-2.9 5.9-2.9 7 0l14.1 35.2h38.7c1.6 0 3.1 1 3.5 2.6.3 1.5-.2 3.2-1.5 4.2z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}